import {Injectable} from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import {Router} from '@angular/router';
import {environment} from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private _masterToken: string;


    constructor(private _router: Router) {
        if (environment.project === 'steiner') {
            this._masterToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwYXNzd29yZCI6InN0ZWluZXIiLCJ1c2VyIjoiYWRtaW4ifQ.8-' +
                'cwyDZXUCgSpx80h6wFkXhAb7y4E185rALaqbKNTC0';
        } else {
            this._masterToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwYXNzd29yZCI6ImJjdyIsInVzZXIiOiJhZG1pbiJ9.' +
                'cUDMDq7Sq1cL7EZDjYTH-2wHN6bV8qNO60Cx_3Ie3EE';
        }
    }

    // -------------------------------------------------------------------------------------------------------------------------------------

    /***
     * Checks if password is correct and potentially logs in user
     * @returns true if pwd correct, false if pwd incorrect
     */
    public login(credentials) {
        const token = this.getDecodedAccessToken(this._masterToken);
        if (credentials === token.password) {
            localStorage.setItem('user', token.user);
            return true;
        }
        return false;
    }

    /**
     * Logs out user
     */
    public logout() {
        localStorage.removeItem('user');
        this._router.navigate(['/auth']);
    }

    /***
     * Checks if user is logged in
     */
    public isLoggedIn() {
        const token = localStorage.getItem('user');
        if (token) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * decodes token
     * @returns decoded token
     */
    public getDecodedAccessToken(token: string) {
        try {
            return jwt_decode(token);
        } catch (e) {
            return null;
        }
    }

}
